module.exports = __webpack_public_path__ + "img/ic_process_no1.71e38a91.png";